import { render, staticRenderFns } from "./Geojson.vue?vue&type=template&id=2544feb4&scoped=true&"
import script from "./Geojson.vue?vue&type=script&lang=js&"
export * from "./Geojson.vue?vue&type=script&lang=js&"
import style0 from "./Geojson.vue?vue&type=style&index=0&id=2544feb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544feb4",
  null
  
)

export default component.exports